import React, { useState, useEffect } from 'react';

const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Find the "See in action" section (DemoVideos component)
      const demoSection = document.querySelector('.demo-grid');
      // Find the main CTA section
      const ctaSection = document.querySelector('.cta-section');
      
      if (!demoSection || !ctaSection) return;
      
      const demoSectionRect = demoSection.getBoundingClientRect();
      const ctaSectionRect = ctaSection.getBoundingClientRect();
      const scrollY = window.scrollY;
      const demoSectionTop = scrollY + demoSectionRect.top;
      const ctaSectionTop = scrollY + ctaSectionRect.top;
      
      // Show sticky CTA after demo section but hide when viewing main CTA section
      const afterDemo = scrollY > demoSectionTop + demoSectionRect.height;
      const beforeCTA = scrollY < ctaSectionTop - 100; // Hide 100px before CTA section
      
      setIsVisible(afterDemo && beforeCTA);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="sticky-cta">
      <div className="sticky-cta-content">
        <span className="sticky-cta-text">Ready to transform your customer service?</span>
        <a 
          href="https://calendly.com/dimitrovovich" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="btn btn-primary sticky-cta-btn"
        >
          Book Free Consultation
        </a>
      </div>
    </div>
  );
};

export default StickyCTA;